/* eslint-disable */
/**
 * Utility functions for printing
 */

/**
 * Decodes a Base64 string to a PDF blob and triggers the browser print dialog or opens in new tab.
 * @param {string} base64String - The Base64 encoded PDF string.
 */
export const printBase64Pdf = (base64String) => {
    try {
        if (!base64String) {
            console.error("printBase64Pdf: No base64 string provided");
            return;
        }
        // Decode Base64 string
        const binaryString = window.atob(base64String);
        const len = binaryString.length;
        const bytes = new Uint8Array(len);
        for (let i = 0; i < len; i++) {
            bytes[i] = binaryString.charCodeAt(i);
        }

        // Create Blob
        const blob = new Blob([bytes], { type: "application/pdf" });
        const blobUrl = window.URL.createObjectURL(blob);

        // Attempt invisible iframe print for seamless experience
        const iframe = document.createElement('iframe');
        iframe.style.position = 'fixed';
        iframe.style.width = '1px';
        iframe.style.height = '1px';
        iframe.style.right = '0';
        iframe.style.bottom = '0';
        iframe.style.border = 'none';
        iframe.style.opacity = '0.01'; // Invisible but rendered
        iframe.style.pointerEvents = 'none';

        // Attributes to hide from screen readers and Copilot/observers
        iframe.setAttribute('data-copilot-ignore', 'true');
        iframe.setAttribute('aria-hidden', 'true');
        iframe.setAttribute('tabIndex', '-1');

        iframe.src = blobUrl;
        document.body.appendChild(iframe);

        iframe.onload = () => {
            setTimeout(() => {
                try {
                    if (iframe.contentWindow) {
                        iframe.contentWindow.focus();
                        iframe.contentWindow.print();
                    }
                } catch (e) {
                    console.error("Print error:", e);
                }
            }, 300);
        };

        // Cleanup
        setTimeout(() => {
            try {
                if (document.body.contains(iframe)) {
                    // document.body.removeChild(iframe);
                    // window.URL.revokeObjectURL(blobUrl);
                }
            } catch (e) {
                // ignore
            }
        }, 60000);

    } catch (error) {
        console.error("Failed to print PDF:", error);
    }
};
